import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, FileText, Flame, Clock, ClipboardList } from 'lucide-react';
const deliverables = [{
  icon: <BookOpen className="text-amber-500" size={24} data-id="element-147" />,
  text: "El Manual PDF 'Farmacia de Despensa' con protocolos paso a paso."
}, {
  icon: <FileText className="text-amber-500" size={24} data-id="element-148" />,
  text: 'La Tabla de Equivalencias: Qué especia reemplaza a qué fármaco común.'
}, {
  icon: <Flame className="text-amber-500" size={24} data-id="element-149" />,
  text: 'Los 5 Pilares de la Activación Térmica para no quemar la medicina.'
}, {
  icon: <Clock className="text-amber-500" size={24} data-id="element-150" />,
  text: 'Protocolos de Alivio en 10 Minutos para Migraña, Acidez, Insomnio y Tos.'
}, {
  icon: <ClipboardList className="text-amber-500" size={24} data-id="element-151" />,
  text: 'Checklist de Inventario: Los 7 imprescindibles que nunca deben faltar en tu cocina.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGetSection() {
  return <section className="py-12 md:py-24 px-4 bg-forest-900 relative overflow-hidden" data-id="element-152">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHBhdGggZD0iTTIwIDBMMCAyMGwyMCAyMCAyMC0yMEwyMCAweiIgZmlsbD0iI2ZmZiIgZmlsbC1vcGFjaXR5PSIuMDUiLz48L3N2Zz4=')] opacity-20" data-id="element-153"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-cream-100 mb-6" data-id="element-156">
            Lo Que Recibirás
          </h2>
          <div className="w-24 h-px bg-amber-500 mx-auto" data-id="element-157"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid gap-4" data-id="element-158">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="group flex items-center gap-6 p-6 rounded-sm bg-forest-800/80 border border-forest-700/50 hover:border-amber-500/50 hover:bg-forest-800 transition-all duration-300 shadow-lg" data-id="element-159">
              <div className="flex-shrink-0 p-3 rounded-full bg-forest-900 border border-amber-500/20 group-hover:scale-110 transition-transform duration-300" data-id="element-160">
                {item.icon}
              </div>
              <p className="font-lora text-cream-100/90 text-lg leading-relaxed" data-id="element-161">
                {item.text}
              </p>
              <div className="ml-auto hidden sm:block opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-162">
                <Check className="text-amber-500/50" size={20} data-id="element-163" />
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}